// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__1YmMQ","colMin":"styles_colMin__3gEbQ","colCheckbox":"styles_colCheckbox__3Wyl2"};